import eventBus from '@/services/eventBus'
import Vue from 'vue';

Vue.prototype.$eventBus = eventBus;
